import type { InsightsDashboardPoolState } from '@aytm/app/insights/dashboard/duckness/ducks/types'
import { getCurrentBlock } from '@aytm/app/insights/dashboard/helpers/requests'
import { compareTuples } from '@aytm/app/insights/dashboard/lib/comparison'

export const stateSelector = (state: InsightsDashboardPoolState) => {
  const block = getCurrentBlock(state)
  const isSharedView = state.isSharedView || false
  const showSigtest = block?.get('showSigtest') ?? true
  const confidenceLevel = block?.get('confidenceLevel') || 0.95
  const secondaryConfidenceLevel = block?.get('secondaryConfidenceLevel') || 0.9
  const blockColors = block?.get('colors') || null
  return {
    isSharedView,
    showSigtest,
    confidenceLevel,
    secondaryConfidenceLevel,
    blockColors
  }
}

export const shouldUpdate = (
  prev: ReturnType<typeof stateSelector> | null,
  next: ReturnType<typeof stateSelector> | null
) =>
  !prev && !next
    ? false
    : (!prev && Boolean(next)) ||
      (Boolean(prev) && !next) ||
      !compareTuples(({ isSharedView, showSigtest, confidenceLevel, secondaryConfidenceLevel, blockColors }) => [
        isSharedView,
        showSigtest,
        confidenceLevel,
        secondaryConfidenceLevel,
        blockColors
      ])(prev, next)
//  prev.isSharedView !== next.isSharedView ||
//   prev.showSigtest !== next.showSigtest ||
//   prev.confidenceLevel !== next.confidenceLevel ||
//   prev.secondaryConfidenceLevel !== next.secondaryConfidenceLevel ||
//   prev.blockColors !== next.blockColors
